import { configureStore } from '@reduxjs/toolkit';

import consignmentReducer from '@/store/slices/consignmentSlice';
import uiReducer from '@/store/slices/uiSlice';
import storageReducer from '@/store/slices/storageSlice';

import { authSlice } from '@/entities/auth';
import { navigationReducer } from '@/entities/navigation';
import { baseApi } from '@/shared/api/base';
import { errorMiddleware } from '@/shared/lib/errors/error-middleware';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    consignment: consignmentReducer,
    ui: uiReducer,
    storage: storageReducer,
    auth: authSlice.reducer,
    navigation: navigationReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware).concat(errorMiddleware)
});

export const setupStore = () => store;
